import { styled } from "@mui/material/styles";
import {
  TextField,
  FormControl,
  Checkbox,
  Slider,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const primaryColor = "#011e37";

// Base styling for all input fields

// Styled TextField component
export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: "0px",
  "& .MuiInputLabel-root": {
    color: "text.primary",
    fontWeight: 500,
  },
}));

// Styled FormControl for select components
export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: "0px",
}));

// Styled Checkbox
export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({}));

// Styled Slider
export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: primaryColor,
}));

// Styled RadioGroup
export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  "& .MuiFormControlLabel-root": {
    marginBottom: "8px",
  },
}));

// Styled Radio
export const StyledRadio = styled(Radio)(({ theme }) => ({
  color: primaryColor,
  "&.Mui-checked": {
    color: primaryColor,
  },
}));

// Styled FormControlLabel
export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    color: "#374151",
  },
}));

// Styled Label
export const StyledLabel = styled("label")(({ theme, required }) => ({
  display: "block",
  color: "text.primary",
  fontWeight: 500,
  marginBottom: "8px",
  "&::after": required
    ? {
        content: '" *"',
      }
    : {},
}));

// Styled FileInput
export const StyledFileInput = styled("div")(({ theme }) => ({
  backgroundColor: "#F8F9FF",
  borderRadius: "8px",
  padding: "16px",
  border: "1px dashed #E5E7EB",
  cursor: "pointer",
  textAlign: "center",
  marginBottom: "16px",
  "&:hover": {
    borderColor: primaryColor,
  },
}));
